import React from 'react';
import { useTranslation } from 'react-i18next';

const BenefitsSection = () => {
  const { t } = useTranslation('latvia');

  const benefits = [
    {
      icon: 'ri-passport-line',
      title: t('benefits.1.title'),
      description: t('benefits.1.desc'),
    },
    {
      icon: 'ri-graduation-cap-line',
      title: t('benefits.2.title'),
      description: t('benefits.2.desc'),
    },
    {
      icon: 'ri-hospital-line',
      title: t('benefits.3.title'),
      description: t('benefits.3.desc'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('benefits.4.title'),
      description: t('benefits.4.desc'),
    },
    {
      icon: 'ri-shield-star-line',
      title: t('benefits.5.title'),
      description: t('benefits.5.desc'),
    },
    {
      icon: 'ri-briefcase-line',
      title: t('benefits.6.title'),
      description: t('benefits.6.desc'),
    },
  ];

  return (
    <section
      id="benefits"
      className="py-6 md:py-20 bg-gradient-to-b from-white to-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-16">
          <h2 className="text-xl md:text-5xl font-bold text-gray-900 mb-2 md:mb-4 font-serif">
            {t('benefits.title')}
          </h2>
          <p className="text-xs md:text-lg text-gray-600 max-w-2xl mx-auto">
            {t('benefits.description')}
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-white rounded-lg md:rounded-xl p-3 md:p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-gold-300 group"
            >
              <div className="w-8 h-8 md:w-16 md:h-16 flex items-center justify-center bg-gradient-to-br from-gold-400 to-gold-600 rounded-md md:rounded-xl mb-2 md:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${benefit.icon} text-base md:text-3xl text-white`}></i>
              </div>
              <h3 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3 leading-snug">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-[10px] md:text-sm leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;